import { render, staticRenderFns } from "./ProposalAppendix.vue?vue&type=template&id=5597cf5a"
import script from "./ProposalAppendix.vue?vue&type=script&lang=js"
export * from "./ProposalAppendix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports